<template>
    <ldc-dialog
        :title="title"
        :colorTitle="colorTitle"
        :clickoutside="true"
        width="50%"
        :fullscreen="$detect == 'mobile'"
        :class="{
            'product-dialog' : true,
            'modal-register-vip': $detect == 'web',
            'modal-mobile-vip position-relative': $detect == 'mobile',
            'modal-HappyLink' : action == 'HappyLink',
            'modal-dght' : action == 'dght',
            'modal-normal' : action == 'auto',
        }"
        :visible.sync="dialog">
        <div class="content-modal py-3 px-10px">
            <div class="d-flex">
                <div :class="{
                            'w-40' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">
                        Sản phẩm:
                    </div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <a :href="$linkUrl(data.link)" class="text-decoration-none link-news"
                            v-if="!multiple" target="_blank">
                            {{data.name}}
                        </a>
                        <p class="mb-0 fw-600 text-primary link-news" v-else>
                            <span v-for="(item, index) in dataMultiple" :key="index">#{{item}}, </span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3" v-if="!multiple">
                <div :class="{
                            'w-40' : true,
                            'fw-600' :  $detect == 'mobile'
                        }" v-if="action == 'HappyLink'">
                    <div class="name">Giá mỗi lần sử dụng dịch vụ HappyLink:</div>
                </div>
                <div class="w-40"  v-if="action == 'dght'">
                    <div class="name">Giá đấu cao nhất theo danh mục :</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <span v-if="action == 'HappyLink'" class="text-danger border-none fw-600    ">{{ $formatNumber(priceHappLink) }} <span style="color: #212529;" class="fw-400">{{money.unit}}</span></span>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div class="w-40">
                    <div :class="{
                            'w-40' : true,
                            'fw-600' :  $detect == 'mobile'
                        }" v-if="action == 'HappyLink'">Link:</div>
                    <div class="name" v-if="action == 'dght'">Chọn mức đấu giá theo lượt hiển thị:</div>

                    <!-- <div class="name">Link:</div> -->
                </div>
                <div class="w-60">
                    <div class="value" v-if="action == 'HappyLink'">
                       <input type="text" class="input-time-vip mr-1 text-right input-link"
                            v-model="link" ref="input-action-dialog" placeholder="Nhập link chuyển hướng của sản phẩm..." 
                            @focus="(e) => e.target.select()"/>
                    </div>
                    <div class="value" v-if="action == 'dght'">
                        <select name="" class="select-dght">
                            <option value="">000000</option>
                            <option value="">000000</option>
                            <option value="">000000</option>
                            <option value="">000000</option>
                            <option value="">000000</option>
                            <option value="">000000</option>

                        </select>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                                'w-40' : true,
                                'd-flex justify-content-center align-items-center fw-600' : $detect == 'mobile'
                            }">
                    <div class="name">Thời gian bắt đầu:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <div class="content-change-time mt-2">
                            <div :class="{'d-flex' : $detect == 'web', 'justify-content-between' : $detect == 'mobile'}">
                                <div :class="{
                                        'fw-600' : true,
                                        'mr-3'   : $detect == 'web',
                                        'mb-1' : $detect == 'mobile'
                                    }">
                                  <input type="date" class="date-change" v-model="startDate"
                                        :min="dayNow"/>
                                </div>
                                <div>
                                    <ldc-time placeholder="HH:mm"
                                        :showSeconds="false"
                                        :jumpMinutes="5"
                                        titleMobile="Thời gian"
                                        v-model="startTime"
                                        class="time-change"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                            'w-40' : true,
                            'd-flex justify-content-center align-items-center fw-600' : $detect == 'mobile'
                        }">
                    <div class="name">Thời gian kết thúc:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <div class="content-change-time mt-2">
                            <div :class="{'d-flex' : $detect == 'web', 'justify-content-between' : $detect == 'mobile'}">
                                <div :class="{
                                        'fw-600' : true,
                                        'mr-3'   : $detect == 'web',
                                        'mb-1' : $detect == 'mobile'
                                    }">
                                  <input type="date" class="date-change" v-model="endDate"
                                        :min="dayNow"/>
                                </div>
                                <div>
                                    <ldc-time placeholder="HH:mm"
                                        :showSeconds="false"
                                        :jumpMinutes="5"
                                        titleMobile="Thời gian"
                                        v-model="endTime"
                                        class="time-change"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                            'w-40' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">Số tiền thiết lập tối đa:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                       <input type="text" class="input-time-vip input-price-vip mr-1 text-right"
                            v-model="max_amount" ref="input-action-dialog" @input="maxAmount()"
                            @focus="(e) => e.target.select()"/>
                            {{money.unit}}
                    </div>
                </div>
            </div>
             <div class="d-flex mt-3">
                <div :class="{
                            'w-40' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">Tự động gia hạn:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <div :class="{
                                'd-flex': true,
                                'mt-1 justify-content-around': $detect == 'mobile',
                            }">
                            <div :class="{
                                    'custom-control custom-radio': true,
                                    'custom-control-inline mr-5': $detect == 'web'
                                }">
                                <input type="radio"
                                    id="autoRadioInline3"
                                    name="auto"
                                    class="custom-control-input"
                                    v-model="auto" :value="1">
                                <label class="custom-control-label"
                                    for="autoRadioInline3">
                                   Có
                                </label>
                            </div>
                            <div :class="{
                                    'custom-control custom-radio': true,
                                    'custom-control-inline ml-5 mr-0': $detect == 'web'
                                }">
                                <input type="radio"
                                    id="autoRadioInline2"
                                    name="auto"
                                    class="custom-control-input"
                                    v-model="auto" :value="0">
                                <label class="custom-control-label"
                                    for="autoRadioInline2">
                                    Không
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div class="w-40">
                    <div class="name">Tài khoản có:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <span class="text-danger border-none span-happy-link fw-600 mr-2">{{money.money_text}} <span style="color: #212529" class="fw-400">{{money.unit}}</span></span>
                        <a href="https://vatgia.com/nap-tien.html" class="text-decoration-none recharge mx-1">(Nạp {{money.unit}})</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-modal text-center">
            <button :class="{
                    'btn btn-confirm my-10px mr-10px': true,
                    'btn-sm': $detect == 'web'
                }"
                :disabled="loading || price > money.money"
                @click="submit()"
                >Xác nhận</button>
            <button :class="{
                    'btn btn-danger my-10px mr-10px': true,
                    'btn-sm': $detect == 'web'
                }"
                v-if="checkDataLink"
                @click="del()"
                >Hủy cài đặt</button>
        </div>
    </ldc-dialog>
</template>
<script>
export default {
    props: ['visible', 'data', 'action', 'multiple', 'dataMultiple'],
    data() {
        return {
            dialog: false,
            title: '',
            oneManipulation: {},
            colorTitle: '',
            amount: '',
            actionMuti: false,
            total: 0,
            loading: false,
            source_pay: this.$detect == 'web' ? 0: 1,
            link :'',
            price : 0,
            startDate : '',
            startTime : '08:00',
            endDate : '',
            endTime : '22:00',
            auto : 1,
            dayNow : '',
            priceHappLink : 0,
            max_amount : 0,
            checkDataLink : false,
        }
    },
    watch: {
        visible(val){
            this.dialog = val;
            
        },
        dialog(val){
            getMoney();
            this.$emit('update:visible', val);
            if(val){
                this.total = 0;
                this.amount = '';
                setTimeout(() => {
                    this.$refs['input-action-dialog'].focus();
                }, 100)
            }
        },
        action(val){
            if(val == 'HappyLink'){
                this.title = 'Cấu hình HappyLink';
                this.oneManipulation = this.config.con_raovat_vip_price;
                this.colorTitle = '#dc3545';
            }else if(val == 'dght'){
                this.title = 'Tham gia đấu giá hiển thị sản phẩm';
                this.oneManipulation = this.config.con_raovat_super_vip_price;
                this.colorTitle = '#20c997';
            }else if(val == 'auto'){
                this.title = 'Up tự động';
                this.oneManipulation = this.config.con_raovat_up_price;
                this.colorTitle = '#0c81f6';
            }
        },
        data(){
            if(this.action == 'HappyLink'){
                this.loadHappyLink();
            }
        },
        amount(newVal, oldVal) {
            if(newVal * 1 == newVal && newVal % 1 == 0){
                if(newVal <= 1000){
                    if(this.actionMuti){

                    }else{
                        this.singleAction();
                    }
                }else{
                    this.amount = 1000;
                }
            }else{
                this.amount = oldVal;
            }
        }
    },
    created (){
        let day = new Date();
        let dayNow = day.getDate() < 10 ? '0'+day.getDate() : day.getDate();
        let m = day.getMonth() + 1 < 10 ? '0'+(day.getMonth()+1) : day.getMonth() + 1;
        this.dayNow = day.getFullYear() + '-' + m + '-' + dayNow;
    },
    computed: {
        config(){
            return this.$store.state.config;
        },
        money(){
            return this.$store.state.money;
        },
    },
    methods: {
        del(){
             apiPost('/v2/products/add_happy_link', {
                iPro: this.data.id,
                action     : 'delete'
            }).then(res => {
                console.log(res)
                this.$message({
                    message: res.message,
                    type: 'success',
                    center: true,
                });
                this.visible = false;
                this.loading = false;
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        maxAmount(){
            this.max_amount = this.$formatNumber(this.max_amount)
        },
        loadHappyLink(){
            apiGet('/v2/products/load_happy_link', {
                id: this.data.id,
            }).then(res => {
                this.priceHappLink = res.price;
                let data = res.rowEstoreRedirect;
                this.dataLink = data;
                // kiểm tra sản phẩm có tham gia happy link k
                this.startDate  = data.id ? data.start_date : this.dayNow;
                this.startTime  = data.id ? data.start_time : this.startTime;
                this.endDate    = data.id ? data.end_date : this.dayNow;
                this.endTime    = data.id ? data.end_time : this.endTime;

                this.max_amount = data.id ? this.$formatNumber(data.max_amount) : 0;
                if(data.auto_extend){
                    this.auto = data.auto_extend ? 1 : 0;
                }else{
                    this.auto = 1
                }
                this.checkDataLink  = data.link ? true : false;
                this.link       = data.id ? data.link : '';


            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        singleAction(){
            if(!this.multiple){
                this.total = this.amount * this.oneManipulation.money;
            }else{
                this.total = this.amount * this.oneManipulation.money * this.dataMultiple.length;
            }
        },
        submit(){
            // if(!this.multiple){
                if(this.action == 'HappyLink'){
                    this.HappyLink(this.data.id);
                }else if(this.action == 'supper-vip'){
                    this.upSupperVip(this.data.id);
                }
            // }else{
            //     if(this.action == 'vip'){
            //         this.upVipMuti();
            //     }else if(this.action == 'supper-vip'){
            //         this.upSupperVipMuti();
            //     }
            // }
        },
        async upVipMuti(){
            let error = [];
            let check = null;
            for (const key in this.dataMultiple) {
                check = await this.upVip(this.dataMultiple[key]);
                if(check){
                    error.push(check);
                }
            }
            this.loading = false;
            this.dialog = false;
            if(error.length == 0){
                this.$message({
                    message: 'Up vip thành công',
                    type: 'success',
                    center: true,
                });
            }else{
                let message = '';
                error.map(item => message += ' #'+item)
                this.$message({
                    message: 'Up vip không thành công với tin rao'+ message,
                    type: 'error',
                    center: true,
                    timeOut: 5000,
                    showClose: true,
                });
            }
        },
         async upSupperVipMuti(){
            let error = [];
            let check = null;
            for (const key in this.dataMultiple) {
                check = await this.upSupperVip(this.dataMultiple[key]);
                if(check){
                    error.push(check);
                }
            }
            this.loading = false;
            this.dialog = false;
            if(error.length == 0){
                this.$message({
                    message: 'Up siêu vip thành công',
                    type: 'success',
                    center: true,
                });
            }else{
                let message = '';
                error.map(item => message += ' #'+item)
                this.$message({
                    message: 'Up siêu vip không thành công với tin rao'+ message,
                    type: 'error',
                    center: true,
                    timeOut: 5000,
                    showClose: true,
                });
            }
        },
        async HappyLink(id){
            this.loading = true;
            let idReturn = null;
            await apiPost('/v2/products/add_happy_link', {
                iPro: id,
                start_date: this.startDate,
                start_time: this.startTime,
                end_date: this.endDate,
                end_time: this.endTime,
                link: this.link,
                active: true,
                max_amount: stringToNumber(this.max_amount),
                auto_extend: this.auto,
                action     : 'add'
            }).then(res => {
                console.log(res)
                this.$message({
                    message: res.message,
                    type: 'success',
                    center: true,
                });
                this.visible = false;
                this.loading = false;
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
            return idReturn;
        },
        async upSupperVip(id){
            this.loading = true;
            let idReturn = null;
            await apiPost('/v2/profile/raovat/up_super_vip', {
                id: id,
                quantity: this.amount*1,
                source_pay: this.source_pay
            }).then(res => {
                let data = res.data;
                if(!this.multiple){
                    let type;
                    if(res.success == 1){
                        type = 'success';
                        this.dialog = false;
                        getMoney();
                    }else{
                        type = 'error'
                    }
                    this.$message({
                        message: res.message,
                        type: type,
                        center: true,
                    });
                    this.total = 0;
                    this.amount = '';
                    this.loading = false;
                }else{
                    if(res.success == 0) idReturn = id;
                }
            })
            return idReturn;
        }
    }
}
</script>
<style lang="scss">
.modal-mobile-vip{
    &.modal-HappyLink{
        .title-dialog{
            background : #dc3545;
        }
    }
}

.modal-mobile-vip{
    .content-modal{
        margin-top : 0;
    }
    &.modal-HappyLink {
        .footer-modal{
            .btn-confirm, .btn-danger{
                width: 40%;
            }
        }
    }
}
    .modal-register-vip, .modal-mobile-vip{
        &.modal-HappyLink{
            .title-dialog {
                border-bottom: 1px solid #dc3545;
            }
            .footer-modal{
                border-top: 1px solid #dc3545;
                .btn-confirm{
                    color: white;
                    background : #dc3545;
                }
            }
        }
        &.modal-dght {
            .title-dialog {
                border-bottom: 1px solid #20c997;
            }
            .footer-modal{
                border-top: 1px solid #20c997;
                .btn-confirm{
                    color: white;
                    background : #20c997;
                }
            }
        }
    }
    .product-dialog{
        .content-change-time{
            .date-change{
                height: 35px;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                color: #606266;
                outline: none;
                cursor: pointer;
            }
        }

        .content-modal{
            .value{
                .select-dght{
                    height: 35px;
                    border-radius: 4px;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    color: #606266;
                    outline: none;
                    cursor: pointer;
                    width: 155px;
                }
                .input-link{
                    width: 95.5%;
                }
                .border-none{
                    border : unset;
                }
                .input-price-vip{
                    width: 155px;
                    color : #dc3545;
                }
                .span-happy-link{
                    border: unset;
                }
            } 
        }
    }
</style>
